class ScrollAnimations {
    constructor() {
        this.observer = null;
        this.animatedElements = new Set();
        this.isMobile = this.checkIfMobile();
    }
    
    checkIfMobile() {
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        
        return isMobileUserAgent || prefersReducedMotion;
    }
    
    init() {
        if (this.isMobile) {
            this.showAllElementsImmediately();
            return;
        }
        
        const isThankYouPage = window.location.pathname.includes('/thank-you') || 
                               window.location.pathname.includes('/thankyou') ||
                               document.body.classList.contains('page-template-thankyou');
        
        if (isThankYouPage) {
            setTimeout(() => {
                this.animateAllElements();
            }, 100);
        } else if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
                            this.animateElement(entry.target);
                            this.animatedElements.add(entry.target);
                            this.observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.1
                }
            );
            
            this.bookingShadowObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
                            this.animateElement(entry.target);
                            this.animatedElements.add(entry.target);
                            this.bookingShadowObserver.unobserve(entry.target);
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: '15% 0px',
                    threshold: 0
                }
            );
            
            this.observeElements();
            this.animateVisibleElements();
        }
    }
    
    showAllElementsImmediately() {
        const elements = document.querySelectorAll('[data-animate]');
        elements.forEach(el => {
            el.classList.add('animate-active');
            this.animatedElements.add(el);
        });
    }
    
    animateAllElements() {
        const elements = document.querySelectorAll('[data-animate]');
        elements.forEach(el => {
            if (!this.animatedElements.has(el)) {
                this.animateElement(el);
                this.animatedElements.add(el);
            }
        });
    }
    
    animateVisibleElements() {
        const elements = document.querySelectorAll('[data-animate]');
        elements.forEach(el => {
            const rect = el.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            
            if (isVisible && !this.animatedElements.has(el)) {
                this.animateElement(el);
                this.animatedElements.add(el);
                if (this.observer) {
                    this.observer.unobserve(el);
                }
            }
        });
    }
    
    observeElements() {
        const elements = document.querySelectorAll('[data-animate]');
        elements.forEach(el => {
            if (!this.animatedElements.has(el)) {
                if (el.classList.contains('booking_shadow') && this.bookingShadowObserver) {
                    this.bookingShadowObserver.observe(el);
                } else if (this.observer) {
                    this.observer.observe(el);
                }
            }
        });
    }
    
    animateElement(element) {
        const animationType = element.getAttribute('data-animate');
        const delay = element.getAttribute('data-animate-delay') || 0;
        
        setTimeout(() => {
            element.classList.add('animate-active');
            
            if (animationType) {
                element.classList.add(`animate-${animationType}`);
            }
        }, parseInt(delay));
    }
    
    refresh() {
        this.observeElements();
    }
}

function initScrollAnimations() {
    const scrollAnimations = new ScrollAnimations();
    
    scrollAnimations.init();
    
    const initMenuAnimation = () => {
        const isMobileNow = scrollAnimations.checkIfMobile();
        const menuItems = document.querySelectorAll('.header__menu-item');
        
        menuItems.forEach(item => {
            if (isMobileNow) {
                item.removeAttribute('data-animate');
                item.removeAttribute('data-animate-delay');
                item.classList.add('animate-active');
                scrollAnimations.animatedElements.delete(item);
            } else {
                if (!item.hasAttribute('data-animate')) {
                    const index = Array.from(menuItems).indexOf(item);
                    item.setAttribute('data-animate', 'fade-up');
                    item.setAttribute('data-animate-delay', (150 + index * 50).toString());
                    item.classList.remove('animate-active');
                    scrollAnimations.animatedElements.delete(item);
                }
            }
        });
        
        if (!isMobileNow && menuItems.length > 0 && scrollAnimations.observer) {
            scrollAnimations.refresh();
            scrollAnimations.animateVisibleElements();
        }
    };
    
    initMenuAnimation();
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const wasMobile = scrollAnimations.isMobile;
            scrollAnimations.isMobile = scrollAnimations.checkIfMobile();
            
            if (wasMobile !== scrollAnimations.isMobile) {
                if (scrollAnimations.isMobile) {
                    scrollAnimations.showAllElementsImmediately();
                } else {
                    scrollAnimations.init();
                }
                initMenuAnimation();
            } else {
                initMenuAnimation();
            }
        }, 150);
    });
    
    return scrollAnimations;
}

export default initScrollAnimations;
